var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPinterest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "leftmenu/social/solid/icon-pinterest") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "1.33055874e-13%",
    x2: "50%",
    y2: "104.53891%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222",
    stopOpacity: 0.7,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222",
    stopOpacity: 0.995478029,
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222",
    stopOpacity: 0.995478029,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15,2 C7.81681682,2 2,7.82118708 2,15.0097671 C2,20.5184072 5.41591592,25.2261458 10.2567568,27.1209617 C10.1396396,26.0856499 10.042042,24.5229151 10.2957958,23.3899324 C10.53003,22.3741548 11.8183183,16.9241172 11.8183183,16.9241172 C11.8183183,16.9241172 11.4279279,16.1427498 11.4279279,14.9902329 C11.4279279,13.1735537 12.481982,11.825695 13.7702703,11.825695 C14.8828829,11.825695 15.4099099,12.6656649 15.4099099,13.6619083 C15.4099099,14.7753569 14.7072072,16.4552968 14.3363363,17.9984974 C14.024024,19.2877536 14.9804805,20.3425995 16.2687688,20.3425995 C18.5720721,20.3425995 20.3483483,17.9008264 20.3483483,14.3846732 C20.3483483,11.2787378 18.1036036,9.09090909 14.9219219,9.09090909 C11.2327327,9.09090909 9.04654655,11.8647633 9.04654655,14.7362885 C9.04654655,15.849737 9.47597598,17.0608565 10.0225225,17.7054846 C10.1201201,17.8422239 10.1396396,17.9398948 10.1201201,18.0766341 C10.0225225,18.486852 9.80780781,19.3658903 9.76876877,19.541698 C9.71021021,19.7761082 9.57357357,19.8347107 9.33933934,19.7175056 C7.71921922,18.9556724 6.7042042,16.5920361 6.7042042,14.677686 C6.7042042,10.5755071 9.69069069,6.80540947 15.2927928,6.80540947 C19.8018018,6.80540947 23.2957958,10.02855 23.2957958,14.3065364 C23.2957958,18.7798648 20.4654655,22.393689 16.5615616,22.393689 C15.2537538,22.393689 14.0045045,21.7099925 13.5750751,20.9090909 C13.5750751,20.9090909 12.9309309,23.3899324 12.7747748,23.9954921 C12.481982,25.1284748 11.6816817,26.5349361 11.1546547,27.4139745 C12.3648649,27.785124 13.6531532,28 15,28 C22.1831832,28 28,22.1788129 28,14.9902329 C28,7.82118708 22.1831832,2 15,2 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-15.4%",
    y: "-7.7%",
    width: "130.8%",
    height: "130.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leftmenu/social/solid/icon-pinterest",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPinterest);
export default __webpack_public_path__ + "static/media/icon-pinterest.4bb0af3012ef9c52ed17465b58711849.svg";
export { ForwardRef as ReactComponent };